import kfetch from '@kareo/kfetch';
import { authenticatedUser, Roles } from './authenticatedUser';
import getSessionId from '../utils/sessionId';
var actionableStates = [
    'NOT_REGISTERED',
    'PENDING_OTP',
    'ERROR',
    'CAMPAIGN_ERROR',
    'LOCKED',
];
export var getA2PRegistrationStatus = function () {
    return kfetch('/messaging-provisioning-ui/api/registration/status');
};
export var getPreferredPartnerPracticeActiveFlag = function () {
    return kfetch('/messages-ui/api/Users/PreferredPartner/Practice');
};
// Share concurrent requests across the banner and reminder status. Do not cache
// settled eligibility: returning from registration must read the latest status.
var pendingEligibility = new Map();
export var getA2PRegistrationBannerStatus = function () {
    var sessionId = String(getSessionId());
    var pending = pendingEligibility.get(sessionId);
    if (pending)
        return pending;
    var request = authenticatedUser
        .getRolesLookup()
        .then(function (roles) {
        var hasRequiredRole = Object.prototype.hasOwnProperty.call(roles, Roles.SystemAdministrator);
        if (!hasRequiredRole)
            return null;
        return Promise.all([
            getA2PRegistrationStatus(),
            getPreferredPartnerPracticeActiveFlag(),
        ]).then(function (_a) {
            var registration = _a[0], isPatientPopCustomer = _a[1];
            return (registration === null || registration === void 0 ? void 0 : registration.formVersion) === 'charge' && isPatientPopCustomer === false
                ? actionableStates.find(function (status) { return status === registration.status; }) ||
                    null
                : null;
        });
    })
        .finally(function () { return pendingEligibility.delete(sessionId); });
    pendingEligibility.set(sessionId, request);
    return request;
};
